/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { initializeReactGA } from '../../middleware/googleAnalytics';
import './library.scss';
import CircleLoader from '../loader/loader';
import { libraryDetails } from './libraryDetails';
import { getInteractiveTitle } from '../formComponent/utils';
import { useDispatch, useSelector } from 'react-redux';
import { ParentDataInterface, setInteractiveState } from '../../redux/parentDataSlice';
import { ReactComponent as InfoIcon } from '../../assets/icons/infoIcon.svg';
import { setInteractiveType } from '../../redux/handleBrowserBack';

const LibraryDashboard = (props: any) => {
  const [loading, setLoading] = useState(true);
  const { pathname } = props.location;
  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  const customConfiguration = useSelector((state: ParentDataInterface) => state.parentData);
  const configCheck = customConfiguration?.customConfiguration?.config;

  const interactiveState = useSelector(
    (state: ParentDataInterface) => state.parentData.interactiveState,
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const isOPenInteractive = interactiveState === 'collaborative';
  const handleSwitchToOriginal = () => {
    dispatch(setInteractiveState('/library'));
    history.push('/library');
    dispatch(setInteractiveType('/library'));
  };
  useEffect(() => {
    if (!dataFromParent || dataFromParent?.type !== 'loreeDetails') {
      props.history.push('/401');
      return;
    }
    const fetchData = async () => {
      initializeReactGA(pathname, dataFromParent);
      setLoading(false);
    };
    fetchData();
  }, [loading, pathname, dataFromParent, props]);

  if (loading) return <CircleLoader loaderType='' />;
  if ((!loading && !dataFromParent) || dataFromParent.type !== 'loreeDetails')
    return <Redirect to='/401' />;
  else {
    return (
      <div className={`${isOPenInteractive ? 'libraryDashboardMain' : ''}`}>
        {isOPenInteractive && (
          <>
            <div className='createOpenInteractiveTitle'>
              <div className='title'>Open Interactive</div>
              {}
              {(configCheck?.myinteractivecreate || configCheck?.globalinteractivecreate) && (
                <Button className='switchBtn' onClick={handleSwitchToOriginal}>
                  Switch to Original
                </Button>
              )}
            </div>
            <div className='openInteractiveInfoBox'>
              <InfoIcon className='infoIcon' />
              <p className='info'>
                Open Interactives work differently from Original Interactives. Once added to a
                template or LMS page, they can be edited by anyone with Loree access in your
                institution. Any edits made to an Open Interactive apply only to that specific
                instance, not the original.
              </p>
            </div>
          </>
        )}
        <Container fluid className='margin landingPageLoreeInteractive' id='interactiveContainer'>
          <Row className='w-100'>
            {/* Cards */}
            <Col md={11} lg={11} id='interactivesColumn'>
              <Row xs={1} md={2} lg={4} className='g-4'>
                {libraryDetails.map((component) => {
                  return (
                    <Col key={component.title}>
                      <Card
                        bsPrefix='card card-style'
                        className='rounded-lg h-100'
                        id='interactiveCards'
                      >
                        <Card.Img
                          src={component.src}
                          alt={component.alt}
                          className='img-fluid p-3'
                        />
                        <Card.Body
                          bsPrefix='card-body title-body mx-3'
                          className='p-0'
                          id='interactiveBody'
                        >
                          <Card.Title className='text-color' id='interactiveTitle'>
                            {getInteractiveTitle(component.title)}
                          </Card.Title>
                          <Card.Text bsPrefix='card-text description-text'>
                            {component.description}
                          </Card.Text>
                        </Card.Body>
                        <Card.Footer
                          className='bg-white border-0 text-center'
                          id='interactiveFooter'
                        >
                          <Link
                            to={{
                              pathname: `${component.pathName}`,
                            }}
                            className='btn btn-sm btn-primary card-create-btn'
                            id='interactiveCreateBtn'
                          >
                            Create
                          </Link>
                        </Card.Footer>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
};

export default LibraryDashboard;
